import React, { useState, FormEvent } from 'react';
import shufflrLogo from '../assets/logo.svg';
import { useAuth } from '../context/AuthContext';
import { useTenant } from '../context/TenantContext';
import {
  authPageStyle, authCardStyle, authLogoStyle, authTaglineStyle,
  authHeadingStyle, authFormStyle, authRowStyle, authLabelStyle,
  authInputStyle, authSubmitStyle, authSwitchStyle, authLinkStyle,
  authErrorStyle, authHintStyle,
} from '../App.styles';

interface RegisterPageProps {
  onSwitchToLogin: () => void;
}

export function RegisterPage({ onSwitchToLogin }: RegisterPageProps): React.JSX.Element {
  const { register } = useAuth();
  const { slug } = useTenant();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!slug) { setError('No organisation found — check your URL.'); return; }
    setError(null);
    setLoading(true);
    try {
      await register(firstName, lastName, email, password, slug);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={authPageStyle}>
      <div style={authCardStyle}>
        <img src={shufflrLogo} alt="Shufflr" style={{ ...authLogoStyle, filter: 'none' }} />
        <p style={authTaglineStyle}>Good Games · Great Vibes</p>
        <h1 style={authHeadingStyle}>Create your account</h1>

        {error && <div style={authErrorStyle}>{error}</div>}

        <form style={authFormStyle} onSubmit={handleSubmit} noValidate>
          <div style={authRowStyle}>
            <label style={authLabelStyle}>
              First name
              <input
                type="text"
                value={firstName}
                onChange={e => setFirstName(e.target.value)}
                placeholder="Mike"
                required
                autoComplete="given-name"
                style={authInputStyle}
              />
            </label>
            <label style={authLabelStyle}>
              Last name
              <input
                type="text"
                value={lastName}
                onChange={e => setLastName(e.target.value)}
                placeholder="Johnson"
                required
                autoComplete="family-name"
                style={authInputStyle}
              />
            </label>
          </div>

          <label style={authLabelStyle}>
            Email
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              autoComplete="email"
              style={authInputStyle}
            />
          </label>

          <label style={authLabelStyle}>
            Password
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="new-password"
              style={authInputStyle}
            />
            <span style={authHintStyle}>8+ chars · uppercase · lowercase · number · special (!@#$%^&*)</span>
          </label>

          <button type="submit" disabled={loading} style={authSubmitStyle}>
            {loading ? 'Creating account…' : 'Create account'}
          </button>
        </form>

        <p style={authSwitchStyle}>
          Already have an account?{' '}
          <button style={authLinkStyle} onClick={onSwitchToLogin} type="button">
            Sign in
          </button>
        </p>
      </div>
    </div>
  );
}

export default RegisterPage;
